<script lang="ts">
  import { page } from '@inertiajs/svelte'
  import { faCheck } from '@fortawesome/free-solid-svg-icons'
  import { getI18n } from '../i18n'
  import { languageLinks } from '../languages'
  import ButtonLink from './ButtonLink.svelte'
  import Icon from './Icon.svelte'

  const i18n = getI18n()
</script>

{#each languageLinks(page.url, i18n.locale) as { code, flag, name, href, current } (code)}
  <ButtonLink {href} {current} variant="button-danger-outline">
    {flag} <span lang={code}>{name}</span>
    {#snippet end()}
      {#if current}<Icon icon={faCheck} />{/if}
    {/snippet}
  </ButtonLink>
{/each}
